import { render, staticRenderFns } from "./AddCreditCard.vue?vue&type=template&id=700f388b&scoped=true&"
import script from "./AddCreditCard.vue?vue&type=script&lang=ts&"
export * from "./AddCreditCard.vue?vue&type=script&lang=ts&"
import style0 from "./AddCreditCard.vue?vue&type=style&index=0&id=700f388b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700f388b",
  null
  
)

export default component.exports